var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "index-free" }, [
    _c(
      "div",
      { staticClass: "main" },
      _vm._l(_vm.imagesList, function(item, index) {
        return _c("img", { key: index, attrs: { src: _vm.baseUrl + item } })
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "footer" }, [
      _c("div", { staticClass: "text", on: { click: _vm.goQues } }, [
        _c("div", { staticClass: "breathe" }, [_vm._v("立即报名")])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bb62ab6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bb62ab6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/official.vue
// module id = WWvh
// module chunks = 1